import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendRequestServiceMutationVariables = Types.Exact<{
  user_text: Types.Scalars['String']['input'];
  user_id: Types.Scalars['String']['input'];
  user_email: Types.Scalars['String']['input'];
  property_id: Types.Scalars['String']['input'];
  workspace_id: Types.Scalars['String']['input'];
  organization_id: Types.Scalars['String']['input'];
  base_url: Types.Scalars['String']['input'];
  attachments?: Types.InputMaybe<Array<Types.AttachmentInput> | Types.AttachmentInput>;
  initial_text?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SendRequestServiceMutation = { __typename?: 'mutation_root', request_service?: { __typename?: 'RequestServiceOutput', success: boolean, request_service_id: string, error?: string | null } | null };


export const SendRequestServiceDocument = gql`
    mutation sendRequestService($user_text: String!, $user_id: String!, $user_email: String!, $property_id: String!, $workspace_id: String!, $organization_id: String!, $base_url: String!, $attachments: [AttachmentInput!], $initial_text: String) {
  request_service(
    user_text: $user_text
    user_id: $user_id
    user_email: $user_email
    property_id: $property_id
    workspace_id: $workspace_id
    organization_id: $organization_id
    attachments: $attachments
    initial_text: $initial_text
    base_url: $base_url
  ) {
    success
    request_service_id
    error
  }
}
    `;
export type SendRequestServiceMutationFn = Apollo.MutationFunction<SendRequestServiceMutation, SendRequestServiceMutationVariables>;

/**
 * __useSendRequestServiceMutation__
 *
 * To run a mutation, you first call `useSendRequestServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRequestServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRequestServiceMutation, { data, loading, error }] = useSendRequestServiceMutation({
 *   variables: {
 *      user_text: // value for 'user_text'
 *      user_id: // value for 'user_id'
 *      user_email: // value for 'user_email'
 *      property_id: // value for 'property_id'
 *      workspace_id: // value for 'workspace_id'
 *      organization_id: // value for 'organization_id'
 *      base_url: // value for 'base_url'
 *      attachments: // value for 'attachments'
 *      initial_text: // value for 'initial_text'
 *   },
 * });
 */
export function useSendRequestServiceMutation(baseOptions?: Apollo.MutationHookOptions<SendRequestServiceMutation, SendRequestServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRequestServiceMutation, SendRequestServiceMutationVariables>(SendRequestServiceDocument, options);
      }
export type SendRequestServiceMutationHookResult = ReturnType<typeof useSendRequestServiceMutation>;
export type SendRequestServiceMutationResult = Apollo.MutationResult<SendRequestServiceMutation>;
export type SendRequestServiceMutationOptions = Apollo.BaseMutationOptions<SendRequestServiceMutation, SendRequestServiceMutationVariables>;